export default "__VITE_ASSET__BNA3sgSH__"